import {
  TextField,
  DateField,
  List,
  Datagrid,
  NumberField,
  ResourceContextProvider,
  useRecordContext,
} from 'react-admin'
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContentText,
  DialogContent,
  Button,
} from '@material-ui/core'
import { useEffect } from 'react'

const Empty = () => {
  return (
    <div>
      <DialogContentText>Vous retrouverez ici vos demandes.</DialogContentText>
    </div>
  )
}
const NumberIdField = ({ source, label }) => {
  const record = useRecordContext()
  return (
    <NumberField
      source={record.ticket_id ? 'ticket_id' : source}
      label={label}
    />
  )
}
const LibelleTextField = ({ source, label }) => {
  const record = useRecordContext()
  return (
    <TextField
      source={record.libelle_ticket ? 'libelle_ticket' : source}
      label={label}
    />
  )
}
export const ExtCoproTicketListDialog = (props) => {
  const copro_id = props.copro_id
  const coproprietaire_id = props.coproprietaire_id

  const setWindowContext = () => {
    window.context['context-extcoproticket-coproid'] = copro_id
    window.context['context-extcoproticket-coproprietaireid'] =
      coproprietaire_id
  }
  useEffect(() => {
    setWindowContext()
  }, [copro_id, coproprietaire_id])

  return (
    <Dialog
      open={props.show}
      onClose={props.handleClose}
      maxWidth="sm"
      fullWidth={true}
    >
      <DialogTitle>Suivre mes demandes</DialogTitle>
      <DialogContent>
        <ResourceContextProvider value="ext_copro_tickets">
          <List
            sort={false}
            pagination={false}
            syncWithLocation
            basePath="/ext_copro_tickets"
            actions={''}
            exporter={false}
            empty={<Empty />}
          >
            <Datagrid rowClick={false} bulkActionButtons={false}>
              <NumberIdField source="id" label="Id" />
              <LibelleTextField source="libelle" label="Nom" />
              <TextField source="step_name" label="Statut de la demande" />
              <DateField source="created" label="Créé le" />
            </Datagrid>
          </List>
        </ResourceContextProvider>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="secondary"
          onClick={props.handleClose}
          disableElevation
        >
          Fermer
        </Button>
      </DialogActions>
    </Dialog>
  )
}
